import { AbyssTheme as themeConfiguration } from '@src/app/browser';
import { RiskCodesTooltip } from '@src/entities/RiskRecord/ui/components/tooltips/RiskCodes';
import { ErrorHandler } from '@src/shared/ui/components/ErrorHandler';
import { IconSymbol } from '@uhg-abyss/web/ui/IconSymbol';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { Tooltip } from '@uhg-abyss/web/ui/Tooltip';
import { isEmpty, isUndefined } from 'lodash';
import React from 'react';

/**
 * RiskCode
 *
 * Displays a color coded risk code with a tooltip that displays the risk code description.
 *
 * @param ireRiskRecord
 * @param riskCodes
 * @param riskRecord
 * @returns {Element}
 * @constructor
 */
export function RiskCode({ ireRiskRecord = {}, riskCodes = [], riskRecord = {} }) {
  let theRiskCode = '';

  if (!isUndefined(riskRecord?.ireRiskRecord?.riskScore)) {
    theRiskCode = riskRecord?.ireRiskRecord?.riskScore;
  }

  if (!isUndefined(ireRiskRecord?.riskReports?.[0]?.publishedRisk)) {
    theRiskCode = ireRiskRecord?.riskReports?.[0]?.publishedRisk;
  }

  let letter;
  const codeDescriptions = [];

  if (!isEmpty(riskCodes)) {
    const codes = theRiskCode?.split('-');
    letter = codes.shift().toUpperCase();

    codes.forEach((codeNumber) => {
      const match = riskCodes.find((riskCode) => {
        return riskCode?.codeId === String(codeNumber);
      });

      if (!isUndefined(match) && !codeDescriptions.includes(match)) {
        codeDescriptions.push(match);
      }
    });
  }

  return (
    <ErrorHandler location="src/pages/private/Analysis/EidSearch/components/Details/components/RiskCode/RiskCode.jsx">
      {isEmpty(theRiskCode) ? (
        <Text color="$gray5">&mdash;</Text>
      ) : (
        <Layout.Group space={Number(themeConfiguration?.theme?.space?.md) || 16}>
          {letter === 'R' && (
            <Layout.Group alignItems="center" space={Number(themeConfiguration?.theme?.space?.xs) || 4}>
              <div>
                <Text color={themeConfiguration?.theme?.colors?.error1} fontWeight="bold">
                  {theRiskCode}
                </Text>
              </div>
              <div>
                <Tooltip asChild content={<RiskCodesTooltip codeDetails={codeDescriptions} />} placement="auto">
                  <IconSymbol color="black" css={{ cursor: 'pointer' }} icon="info" size="$md" variant="outlined" />
                </Tooltip>
              </div>
            </Layout.Group>
          )}

          {letter === 'Y' && (
            <Layout.Group>
              <div>
                <Text color={themeConfiguration?.theme?.colors?.warning1} fontWeight="bold">
                  {theRiskCode}
                </Text>
              </div>

              <div>
                <Tooltip asChild content={<RiskCodesTooltip codeDetails={codeDescriptions} />} placement="auto">
                  <IconSymbol color="black" css={{ cursor: 'pointer' }} icon="info" size="$md" variant="outlined" />
                </Tooltip>
              </div>
            </Layout.Group>
          )}

          {letter === 'G' && (
            <Text color={themeConfiguration?.theme?.colors?.success1} fontWeight="bold">
              {theRiskCode}
            </Text>
          )}
        </Layout.Group>
      )}
    </ErrorHandler>
  );
}
